
export const setNav = ({ commit, state }, value) => {
    commit("SET_NAV", value);
    commit("SET_NAVBAR_RE_RENDER", state.navbarReRender + 1);
};

export const setSectionHover = ({ commit}, value) => {
    commit("SET_SECTION_HOVER", value);
};

export const setLayoutStyle = ({ commit, state }, value) => {
    commit("SET_LAYOUT_STYLE", value);
};

export const setOpenStyleFromSection = ({commit}, value) => {
    commit('SET_OPEN_STYLE_FROM_SECTION', value)
}

export const setSelectedPage = ({commit}, value) => {
    commit('SET_SELECTED_PAGE', value)
}
